import React, { Fragment, useEffect, useState } from 'react';
import {Col, Nav, NavItem, NavLink, Row,TabPane,TabContent, Form} from 'reactstrap';
import { useLocation, useNavigate } from 'react-router';
import moment from 'moment';
import { activeDeactiveClinic, clearClinicEHRConnection, getClinicById, updateClinicforEHR, updateClinicLogo } from '../../api/orgnizations';
import { useConfirmDialog } from '../../hooks/useConfirmDialog';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader/Loader';
import { failed, success } from '../../utils/Tostify';
import EditClinicModal from './EditClinicModel';
import "./Organization.css";
import { decryptData } from '../../utils/helper';
import { handleFileUpload } from '../../utils/ImageToBase64';
import noProfileImg from "../../../src/assets/images/noImage.jpg";
import { getAssignedClinicStaffs } from '../../api/User';
import classnames from 'classnames';
import AssignUser from './AssignUser';
import TextInput from '../../components/InputFields/TextInput';
import { Link } from 'react-router-dom';

function ClinicViewDetail() {
  let token = useSelector((state) => state.userReducer.token);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showClinicModal, setShowClinicModal] = useState(false);
  const ClinicData = location?.state?.clinicData;
  const OrgDetails = location?.state?.orgDetails;
  const [clinicDetails, setClinicDetails] = useState(ClinicData);
  const [assignedClinicUserList, setAssignedClinicUserList] = useState([]);
  const [updatedClinicData, setUpdatedClinicData] = useState(ClinicData);
  const [isActive, setIsActive] = useState(ClinicData?.active);
  const { getConfirmation } = useConfirmDialog();
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAssignUserModal, setshowAssignUserModal] = useState(false);
  const [orgData, setOrgData] = useState({});
  const [clinicId, setClinicId] = useState(clinicDetails?.clinicId || '');
  const [systemListId, setSystemListId] = useState(clinicDetails?.systemListId || '');
  const [clientId, setclientId] = useState(clinicDetails?.clientId || '');
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [errors, setErrors] = useState({});
  const currentClinicId =  localStorage.getItem("currentHospitalId");
  const organizationId = localStorage.getItem("currentOrgId");
  const clinicIdFromState = location.state?.id;
  const isClearDisabled = !clientId.trim() && !clinicId.trim() && !systemListId.trim();
  const [isEditingClientId, setIsEditingClientId] = useState(false);
  const isExistingClientId = !!clinicDetails?.clinicId; // Replace with your actual source

  useEffect(() => {
    setClinicId(clinicDetails?.clinicId || '');
    setSystemListId(clinicDetails?.systemListId || '');
    setclientId(clinicDetails?.clientId || '');
  }, [clinicDetails]);

  useEffect(() => {
    const isChanged =
      clientId.trim() !== (clinicDetails?.clientId || '').trim() ||
      clinicId.trim() !== (clinicDetails?.clinicId || '').trim() ||
      systemListId.trim() !== (clinicDetails?.systemListId || '').trim();

    setIsFormChanged(isChanged);
  }, [clientId, clinicId, systemListId, clinicDetails]);

  const handleActiveInActiveClinic = async(e)=>{
    // Store the current checkbox state
    const currentChecked = e.target.checked;
    // Temporarily revert the checkbox state to prevent immediate visual change
    e.target.checked = !currentChecked;
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: currentChecked ? `Are you sure you want to enable the ${ClinicData?.name}. This will allow previously added users to access this location.` : `Are you sure you want to disable the ${ClinicData?.name}. This will restrict access for all the users who were previously added to the location until it is enabled again.`
    });
    if (confirmed) {
      let res;
      try {
        setIsLoading(true);
        res = await activeDeactiveClinic({ dispatch, token, clinicId: ClinicData?._id, isActive: currentChecked });
        if (res?.status === "SUCCESS") {
          await getClinic();
          setIsActive(currentChecked);
          setIsLoading(false);
          success(currentChecked ? `The ${ClinicData?.name} has been successfully enabled. Users and locations can be added to access the platform.` : `The ${ClinicData?.name} has been successfully disabled. Users of this organization can no longer access the platform.`);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    } else {
      e.target.checked = !currentChecked;
    }
  };

  const getClinic = async () => {
    let res;
    const clinicId = clinicIdFromState || ClinicData?._id;
    try {
      setIsLoading(true);
      res = await getClinicById({ dispatch, token, clinicId});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setClinicDetails(responseData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

   const getAssignedClinicUserList = async (page = 1, limit = 10, searchKey = "") => {
      let res = "";
      const clinicId = clinicIdFromState || clinicDetails?._id;

      try {
        setIsLoading(true);
        res = await getAssignedClinicStaffs({
          dispatch,
          token,
          page,
          limit,
          searchKey,
          // orgId: OrgDetails?._id,
          orgId: clinicDetails?.partOf?._id,
          clinicId,
          dataLimit: "all"
        });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          setAssignedClinicUserList(responseData);
          setIsLoading(false);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };

  const handleImageChange = async(e) => {
		if (e.target.files && e.target.files[0]) {
      const confirmed = await getConfirmation({
        title: "Attention!",
        // entryName,
        actionBtnTitle: "Yes",
        message: `Are you sure want to update the logo ?`
      });
      if (confirmed) {
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
        let res;
        try {
          setIsLoading(true);
          const values = {
            orgLogo: e.target.files[0]
          };
          let base64OrgLogo = "";
          if (values?.orgLogo) {
            base64OrgLogo = await handleFileUpload(values?.orgLogo);
          }
          const fileExtension = values?.orgLogo?.type?.split("/")[1];
          const orgLogoURL = {
            base64String: base64OrgLogo,
            extension: fileExtension, // Add the file extension to the object
            name: values?.orgLogo.name
          };
          values.orgLogo = orgLogoURL;
          res = await updateClinicLogo({ values, dispatch, token, clinicId: ClinicData?._id });
          if (res?.status == "SUCCESS") {
            await getClinic();
            setIsLoading(false);
            success(res?.message);
          } else {
            failed(res.data.message);
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          failed(res?.message);
        }
      }
    }
  };

  useEffect(() => {
  if (location?.state?.id || location?.state?.clinicData?._id) {
    getClinic();
  }
  }, [location?.state]);

  useEffect(() => {
    if (clinicDetails?._id && clinicDetails?.partOf?._id) {
      getAssignedClinicUserList();
    }
  }, [clinicDetails]);

  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSort = () => {

  };

  const handleAddUserClinic = (orgData, clinicData) => {
    setshowAssignUserModal(true);
    setOrgData({...orgData, clinicData});
 };

  const validateFields = () => {
    const newErrors = {};
    if (!clientId.trim()) newErrors.clientId = 'Client ID is required';
    if (!clinicId.trim()) newErrors.clinicId = 'Clinic ID is required';
    if (!systemListId.trim()) newErrors.systemListId = 'System List ID is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConnect = async () => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: `Are you sure you want to connect EHR Connection`
    });
    if (!confirmed) return;
    if (!validateFields()) return;
    const values = {
      clientId,
      clinicId,
      systemListId
      // connectionStatus: true
    };
    try {
      setIsLoading(true);
      const res = await updateClinicforEHR({values, dispatch, token, clinicId: clinicDetails._id, currentClinicId, organizationId});
      if (res?.status === "SUCCESS") {
        success(res?.message);
        await getClinic();
      } else {
        failed(res?.message || "Failed to update");
      }
      setIsLoading(false);
    } catch (error) {
      failed("Something went wrong");
      setIsLoading(false);
      setShowClinicModal(false);
    }
  };

  const handleClearConnection = async () => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      message: `Are you sure you want to clear the EHR connection?`,
      actionBtnTitle: "Yes"
    });
    if (!confirmed) return;

    try {
      setIsLoading(true);

      const values = {
        clientId: "",
        clinicId: "",
        systemListId: "",
        connectionStatus: false
      };

      const res = await clearClinicEHRConnection({
        values,
        dispatch,
        token,
        clinicId: clinicDetails._id,
        currentClinicId,
        organizationId
      });

      if (res?.status === "SUCCESS") {
        success(res?.message);
        await getClinic(); // Refresh details
      } else {
        failed(res?.message || "Failed to clear connection");
      }
    } catch (error) {
      failed("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      {showClinicModal && <EditClinicModal getUpdatedData={(data) => setUpdatedClinicData(data)} refetch={getClinic} clinicData={{ ...clinicDetails, orgName: ClinicData?.orgName }} setShowClinicModal={() => setShowClinicModal(!showClinicModal)} />}
      {/* <button className="save_btn" onClick={() => navigate("/super-admin/orgnization")}>{"Back"}</button> */}
      {showAssignUserModal && <AssignUser orgData={orgData} from={"clinic"}
      setShowAssignModal={() => setshowAssignUserModal(!showAssignUserModal)} refetch={getAssignedClinicUserList}
      setUpdatedUserList={()=>{}} assignedUserList={assignedClinicUserList?.items} />}
    <div className='organization_view_details paginator_blk table_listing_color'>
    <Nav tabs>
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === '1' })}
        onClick={() => toggle('1')}
      >
        Details
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === '2' })}
        onClick={() => toggle('2')}
      >
        Users ({clinicDetails?.userCount || 0})
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === '3' })}
        onClick={() => toggle('3')}
      >
        EHR Connection
      </NavLink>
    </NavItem>
    </Nav>

    <TabContent activeTab={activeTab} className="mt-4">
      {/* ✅ DETAILS TAB */}
      <TabPane tabId="1">
      <div className='organization_view_details'>
        <Row>
          <Col sm="12">
            <div className='profile_block'>
              <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                <div className='profile_info'>
                  <div className="img_block">
                      <div className="img_profile_container">
                        {selectedImage ? (
                          <img src={selectedImage} alt="Profile" className="img_profile_one" />
                        ) : clinicDetails?.orgLogo?.signedUrl ? (
                          <img src={clinicDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                        ) : (
                          <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                        )}
                      </div>
                    <div className="edit_img">
                      <i className='fas fa-pen'></i>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="img_upload_input"
                    />
                  </div>
                  <div>
                    <h6>{clinicDetails?.name}</h6>
                    <p>Hospital</p>
                  </div>
                </div>
                <button className='edit_profile' onClick={() => setShowClinicModal(true)}>Edit Details</button>
              </div>
              <div className='data_profile'>
                <div className='row'>
                  <div className='col-lg-3 col-md-6 mb-3'>
                  <h4>Organization</h4>
                    <p>{clinicDetails?.partOf?.name}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                    <h4>Hospital Type</h4>
                    <p>{clinicDetails?.type}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                    <h4>Primary Contact</h4>
                    <p>{clinicDetails?.contact?.[0]?.name} | {clinicDetails?.contact?.[0]?.telecom.find((val) => val.system == "email")?.value}
                      <br />
                      {clinicDetails?.contact?.[0]?.telecom.find((val) => val.system == "phone")?.value ? "+" + clinicDetails?.contact?.[0]?.telecom.find((val) => val.system == "phone")?.value : "NA"}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                    <h4>Secondary Contact</h4>
                    <p>{(clinicDetails?.contact?.[1]?.name && clinicDetails?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value) ? clinicDetails?.contact?.[1]?.name | clinicDetails?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value : "NA"}
                      <br />
                      {clinicDetails?.contact?.[1]?.telecom.find((val) => val.system == "phone")?.value}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                    <h4>Address</h4>
                    <p>{clinicDetails?.address?.[0]?.city + "," + clinicDetails?.address?.[0]?.state},
                      <br />{clinicDetails?.address?.[0]?.country} - {clinicDetails?.address?.[0]?.postalCode}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                    <div className=''>
                      <h4>Create Date</h4>
                      <p>{moment(clinicDetails?.createdAt).format("MMM-DD-YYYY")}</p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                  <h4>Phone</h4>
                  <p>{clinicDetails?.telecom?.find((val) => val.system == "phone")?.value}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                  <h4>Total Users</h4>
                  <p>{ClinicData?.userCount}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                  <h4>Update Date</h4>
                  <p>{moment(clinicDetails?.updatedAt).format("MMM-DD-YYYY")}</p>
                  </div>
                  <div className='col-lg-3 col-md-6 mb-3'>
                  <h4 className='mb-2'>Active Status</h4>
                    <p> <div className="toggle">
                      <input type="checkbox" id="checktoggle" checked={clinicDetails?.active} onChange={(e) => handleActiveInActiveClinic(e)} />
                      <label htmlFor="checktoggle"></label>
                    </div></p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className="d-flex gap-3 justify-content-center mt-3">
          <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
        </div>
      </div>
      </TabPane>

      {/* ✅ USERS TAB */}
      <TabPane tabId="2">
      <div className='organization_view_details'>
        <Row>
            <Col sm="12">
              <div className='profile_block'>
                <div className='profile_main d-flex justify-content-between align-items-center'>
                  <div className='profile_info'>
                  <div className="img_block">
                      <div className="img_profile_container">
                        {selectedImage ? (
                          <img src={selectedImage} alt="Profile" className="img_profile_one" />
                        ) : clinicDetails?.orgLogo?.signedUrl ? (
                          <img src={clinicDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                        ) : (
                          <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                        )}
                      </div>
                    <div className="edit_img">
                      <i className='fas fa-pen'></i>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="img_upload_input"
                    />
                  </div>
                    <div>
                      <h6>{clinicDetails?.name}</h6>
                      <p>Hospital</p>
                    </div>
                  </div>
                  <button className='edit_profile' onClick={()=> setShowClinicModal(true)}>Edit Details</button>
                </div>
                <div className="table_space">
                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr className="header_table">
                          <th onClick={() => handleSort("firstName")}>Full Name <i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("email")}>Email<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("employer")}> Employer<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("location")}>Location<i className='fas fa-sort'></i></th>
                          <th onClick={() => handleSort("createdAt")}>Joined<i className='fas fa-sort'></i></th>
                          <th>Active</th>
                          <th></th>
                        </tr>
                      </thead>
                      {assignedClinicUserList?.items?.map((user, index) => (
                        <tbody key={user?._id}>
                          <tr><td colSpan={9} height={5} className="bg_light"></td></tr>
                          <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                            <Link
                                to="/super-admin/user-details"
                                className="title_name"
                                state={user}
                            >
                            <td>{user?.firstName + " " + user?.lastName}</td>
                            </Link>
                            <td>{user?.email}</td>
                            <td>{user?.employer}</td>
                            <td>{user?.city + "," + user?.state}</td>
                            <td>{moment(user?.createdAt).format("MMM-DD-YYYY")}</td>
                            <td><div className={user?.active === true ? "active_block_btn" : "not_active_btn"}>{user?.active == true ? "Active" : "Not Active"}</div></td>
                            <td>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={9} height={5} className="bg_light"></td>
                          </tr>
                        </tbody>))}
                    </table>
                  </div>
                    {/* <CustomPagination tableData={assignedUserList?.items} totalPages={assignedUserList?.totalPages} totalRows={assignedUserList?.totalItems} rowsPerPage={10} page={assignedUserList?.items?.length > 0 ? assignedUserList?.currentPage : 0} handlePage={handlePagination} /> */}
                    {/* <CustomPagination
                      tableData={filteredUsers}  // Pass full data
                      totalPages={Math.ceil(filteredUsers.length / ITEMS_PER_PAGE)}
                      totalRows={filteredUsers.length}
                      rowsPerPage={ITEMS_PER_PAGE}
                      page={currentPage}
                      handlePage={(page) => setCurrentPage(page)}  // Update page state
                    /> */}
                  </div>
              </div>
            </Col>
        </Row>
        <div className="d-flex gap-3 justify-content-center mt-3">
            <button className="save_btn_blockk" type="submit" onClick={()=> navigate(-1)}>Back</button>
            <button className='acess_btn d-flex align-items-center gap-2' disabled={clinicDetails?.active === false} onClick={()=> {handleAddUserClinic(OrgDetails, ClinicData);}}><i className="fa fa-plus"></i>Add User Access</button>
        </div>
      </div>
      </TabPane>

      <TabPane tabId="3">
        <div className='organization_view_details'>
          <Row>
            <Col sm="12">
              <div className='profile_block'>
                <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                  <div className='profile_info'>
                    <div className="img_block">
                      <div className="img_profile_container">
                        {selectedImage ? (
                          <img src={selectedImage} alt="Profile" className="img_profile_one" />
                        ) : clinicDetails?.orgLogo?.signedUrl ? (
                          <img src={clinicDetails.orgLogo.signedUrl} alt="Profile" className="img_profile_one" />
                        ) : (
                          <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                        )}
                      </div>
                      <div className="edit_img">
                        <i className='fas fa-pen'></i>
                      </div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="img_upload_input"
                      />
                    </div>
                    <div>
                      <h6>{clinicDetails?.name}</h6>
                      <p>Hospital</p>
                    </div>
                  </div>
                  <button className='edit_profile' onClick={() => setShowClinicModal(true)}>Edit Details</button>
                </div>

                <Form>
                  <div className="organization_form_block organization_modal">
                    <Row>
                      {/* <Col lg={6} className="location_block mb-3">
                        <TextInput
                          label="Client Id"
                          value={clientId}
                          onChange={(e) => setclientId(e.target.value)}
                          placeholder="Client Id"
                          error={errors.clientId}
                        />
                        {errors && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors?.clientId}</div>}
                      </Col> */}
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          label="Client Id"
                          value={
                            isEditingClientId || !isExistingClientId
                              ? clientId // show full while typing or new entry
                              : clientId.length > 4
                                ? clientId.slice(-4).padStart(clientId.length, '*') // mask all but last 4
                                : clientId
                          }
                          onFocus={() => setIsEditingClientId(true)}
                          onBlur={() => setIsEditingClientId(false)}
                          onChange={(e) => setclientId(e.target.value)}
                          placeholder="Client Id"
                          error={errors.clientId}
                        />
                        {errors?.clientId && (
                          <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                            {errors.clientId}
                          </div>
                        )}
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          label="Clinic Id"
                          value={clinicId}
                          onChange={(e) => setClinicId(e.target.value)}
                          placeholder="Clinic Id"
                          error={errors.clinicId}
                        />
                        {errors && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors?.clinicId}</div>}
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          label="System List Id"
                          value={systemListId}
                          onChange={(e) => setSystemListId(e.target.value)}
                          placeholder="System List Id"
                          error={errors.systemListId}
                        />
                        {errors && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors?.systemListId}</div>}

                      </Col>

                      <div className='col-lg-4 mb-3'>
                        <p>Connection Status:</p>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <p
                            style={{
                              backgroundColor: clinicDetails?.connectionStatus ? 'green' : 'gray',
                              color: 'white',
                              padding: '5px',
                              border: 'none',
                              borderRadius: '5px',
                              fontSize: '14px'
                            }}
                          >
                            {clinicDetails?.connectionStatus ? 'Active' : 'Not Active'}
                          </p>
                        </div>
                      </div>
                    </Row>
                  </div>
                </Form>

              </div>
            </Col>
          </Row>

          <div className="d-flex gap-3 justify-content-center mt-3">
            <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
            <button className="save_btn_blockk" type="submit" onClick={handleConnect} disabled={!isFormChanged}>Connect</button>
            <button className="save_btn_blockk" type="submit" onClick={handleClearConnection} disabled={isClearDisabled}>Clear Connection</button>
          </div>
        </div>
      </TabPane>

    </TabContent>
    </div>

    </Fragment>
  );
}

export default ClinicViewDetail;
